import type { CountryCode } from '@handyhand/i18n';
import type { AppEnv, DeployEnv } from './app-env';
import { DEPLOY_ENV } from './deploy-env';

import { environment as dkLocal } from './handyhand/environment.dk';
import { environment as dkDev } from './handyhand/environment.dev.dk';
import { environment as dkProd } from './handyhand/environment.prod.dk';

import { environment as nlLocal } from './handyhand/environment.nl';
import { environment as nlDev } from './handyhand/environment.dev.nl';
import { environment as nlProd } from './handyhand/environment.prod.nl';

/**
 * Lookup table for every (country, deploy-env) combination. The build time
 * only fixes `DEPLOY_ENV`; the country is resolved at runtime from the
 * request host via `@handyhand/i18n`'s `resolveCountryFromDomain`.
 */
export const ENVS: Record<CountryCode, Record<DeployEnv, AppEnv>> = {
  dk: {
    local: dkLocal as AppEnv,
    dev: dkDev as AppEnv,
    prod: dkProd as AppEnv,
  },
  nl: {
    local: nlLocal as AppEnv,
    dev: nlDev as AppEnv,
    prod: nlProd as AppEnv,
  },
};

export function pickEnv(country: CountryCode): AppEnv {
  return ENVS[country][DEPLOY_ENV];
}

export { DEPLOY_ENV };
